module.exports = __webpack_public_path__ + "files/mourlan.a9ccd47155c8b8e69534a0cb3e72baa2.pdf";